import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { CreateWhatsappTemplateSchema } from "schema"
import { z } from "zod"

export const useCreateWhatsappTemplateMutation = () => {
  return useMutation({
    mutationFn: async ({ props }: { props: z.infer<typeof CreateWhatsappTemplateSchema> }) => {
      const { data } = await axios.post(`/integrations/whatsapp/templates`, props)
      return data.data
    },
  })
}
